/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedRunsIndexRouteImport } from './routes/_authenticated/runs.index'
import { Route as AuthenticatedRunsNewRouteImport } from './routes/_authenticated/runs.new'
import { Route as AuthenticatedRunsRunIdIndexRouteImport } from './routes/_authenticated/runs.$runId.index'
import { Route as AuthenticatedRunsRunIdInviteOpsRouteImport } from './routes/_authenticated/runs.$runId.invite-ops'
import { Route as AuthenticatedRunsRunIdEditRouteImport } from './routes/_authenticated/runs.$runId.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRunsIndexRoute = AuthenticatedRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRunsNewRoute = AuthenticatedRunsNewRouteImport.update({
  id: '/runs/new',
  path: '/runs/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRunsRunIdIndexRoute =
  AuthenticatedRunsRunIdIndexRouteImport.update({
    id: '/runs/$runId/',
    path: '/runs/$runId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRunsRunIdInviteOpsRoute =
  AuthenticatedRunsRunIdInviteOpsRouteImport.update({
    id: '/runs/$runId/invite-ops',
    path: '/runs/$runId/invite-ops',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRunsRunIdEditRoute =
  AuthenticatedRunsRunIdEditRouteImport.update({
    id: '/runs/$runId/edit',
    path: '/runs/$runId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/runs/new': typeof AuthenticatedRunsNewRoute
  '/runs/': typeof AuthenticatedRunsIndexRoute
  '/runs/$runId/edit': typeof AuthenticatedRunsRunIdEditRoute
  '/runs/$runId/invite-ops': typeof AuthenticatedRunsRunIdInviteOpsRoute
  '/runs/$runId/': typeof AuthenticatedRunsRunIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/': typeof AuthenticatedIndexRoute
  '/runs/new': typeof AuthenticatedRunsNewRoute
  '/runs': typeof AuthenticatedRunsIndexRoute
  '/runs/$runId/edit': typeof AuthenticatedRunsRunIdEditRoute
  '/runs/$runId/invite-ops': typeof AuthenticatedRunsRunIdInviteOpsRoute
  '/runs/$runId': typeof AuthenticatedRunsRunIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/runs/new': typeof AuthenticatedRunsNewRoute
  '/_authenticated/runs/': typeof AuthenticatedRunsIndexRoute
  '/_authenticated/runs/$runId/edit': typeof AuthenticatedRunsRunIdEditRoute
  '/_authenticated/runs/$runId/invite-ops': typeof AuthenticatedRunsRunIdInviteOpsRoute
  '/_authenticated/runs/$runId/': typeof AuthenticatedRunsRunIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account'
    | '/settings'
    | '/users'
    | '/runs/new'
    | '/runs/'
    | '/runs/$runId/edit'
    | '/runs/$runId/invite-ops'
    | '/runs/$runId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/account'
    | '/settings'
    | '/users'
    | '/'
    | '/runs/new'
    | '/runs'
    | '/runs/$runId/edit'
    | '/runs/$runId/invite-ops'
    | '/runs/$runId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/account'
    | '/_authenticated/settings'
    | '/_authenticated/users'
    | '/_authenticated/'
    | '/_authenticated/runs/new'
    | '/_authenticated/runs/'
    | '/_authenticated/runs/$runId/edit'
    | '/_authenticated/runs/$runId/invite-ops'
    | '/_authenticated/runs/$runId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/runs/': {
      id: '/_authenticated/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof AuthenticatedRunsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/runs/new': {
      id: '/_authenticated/runs/new'
      path: '/runs/new'
      fullPath: '/runs/new'
      preLoaderRoute: typeof AuthenticatedRunsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/runs/$runId/': {
      id: '/_authenticated/runs/$runId/'
      path: '/runs/$runId'
      fullPath: '/runs/$runId/'
      preLoaderRoute: typeof AuthenticatedRunsRunIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/runs/$runId/invite-ops': {
      id: '/_authenticated/runs/$runId/invite-ops'
      path: '/runs/$runId/invite-ops'
      fullPath: '/runs/$runId/invite-ops'
      preLoaderRoute: typeof AuthenticatedRunsRunIdInviteOpsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/runs/$runId/edit': {
      id: '/_authenticated/runs/$runId/edit'
      path: '/runs/$runId/edit'
      fullPath: '/runs/$runId/edit'
      preLoaderRoute: typeof AuthenticatedRunsRunIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedRunsNewRoute: typeof AuthenticatedRunsNewRoute
  AuthenticatedRunsIndexRoute: typeof AuthenticatedRunsIndexRoute
  AuthenticatedRunsRunIdEditRoute: typeof AuthenticatedRunsRunIdEditRoute
  AuthenticatedRunsRunIdInviteOpsRoute: typeof AuthenticatedRunsRunIdInviteOpsRoute
  AuthenticatedRunsRunIdIndexRoute: typeof AuthenticatedRunsRunIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedRunsNewRoute: AuthenticatedRunsNewRoute,
  AuthenticatedRunsIndexRoute: AuthenticatedRunsIndexRoute,
  AuthenticatedRunsRunIdEditRoute: AuthenticatedRunsRunIdEditRoute,
  AuthenticatedRunsRunIdInviteOpsRoute: AuthenticatedRunsRunIdInviteOpsRoute,
  AuthenticatedRunsRunIdIndexRoute: AuthenticatedRunsRunIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
